<script setup>
const props = defineProps({
  images: {
    type: Array,
    required: true,
  },
  showTitle: {
    type: Boolean,
    required: false,
  },
  description: {
    type: Object,
    required: false,
  },
  title: {
    type: String,
    required: true,
  },

})

const currentIndex = ref(0)
const nextIndex = computed(() =>
  currentIndex.value + 1 === props.images.length - 1
    ? 0
    : currentIndex.value + 1
)
const nextNextIndex = computed(() =>
  nextIndex.value + 1 === props.images.length - 1 ? 0 : nextIndex.value + 1
)
const currentImage = computed(() => props.images[currentIndex.value])
const nextImage = computed(() => props.images[nextIndex.value])
const nextNextImage = computed(() => props.images[nextNextIndex.value])

function showImage(index) {
  currentIndex.value = index
}
</script>

<template>
  <h4 v-if="showTitle" class="text__headline text__headline-4 grid-item-title" >{{title}}</h4>

  <section class="module-image-gallery" :id="title">
    <button
      @click="showImage(nextIndex)"
      class="module-image-gallery__container"
    >
      <Transition>
        <img
          :src="currentImage.src"
          :key="currentImage.src"
          class="module-image-gallery__image"
          alt=""
        />
      </Transition>
    </button>

    <nav class="module-image-gallery__nav">
      <span
        class="module-image-gallery__nav-dot module-image-gallery__nav-dot--small"
      />
      <span
        class="module-image-gallery__nav-dot module-image-gallery__nav-dot--medium"
      />
      <span class="module-image-gallery__nav-thumbnail">
        <img :src="nextImage.thumbnails.thul"  alt=""/>
      </span>
      <span
        class="module-image-gallery__nav-dot module-image-gallery__nav-dot--medium"
      />
      <span
        class="module-image-gallery__nav-dot module-image-gallery__nav-dot--small"
      />
    </nav>
  </section>
  <ContentfulRichText v-if="showTitle && description"  :json="description.json" size="small" />

</template>

<style lang="scss">
@import 'styles/vendors/sass-mq/mq';
@import 'styles/utils/variables';
@import 'styles/utils/functions';

.module-image-gallery {
  position: relative;
  margin: 0 auto;
  width: 100%;

  @include mq($from: 'm') using ($from) {
    max-width: gs(5, 4, 'xxxs');
  }

  @include mq($from: 'l') using ($from) {
    max-width: gs(18, 17, 'l');
  }

  &__container {
    width: 100%;
    padding-top: 56.26%;
  }

  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 10;
    clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% calc(100% + 240px));

    transition: clip-path 0.5s ease-out;

    &.v-leave-active {
      clip-path: polygon(0 0, 100% 0%, 100% calc(0% - 240px), 0% 0%);
      z-index: 11;
    }
  }

  &__nav {
    position: absolute;
    z-index: 20;
    right: gs(1, 1, 'l');
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;

    > *:not(:last-child) {
      margin-bottom: 8px;
    }

    &-thumbnail {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: linear-gradient(110.59deg, #c80afb 7.52%, #2919a9 153.34%);
      padding: 2px;

      img {
        border-radius: 50%;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &-dot {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: $brand-white;

      &--small {
        width: 2px;
        height: 2px;
      }
    }
  }
}
</style>
